import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip } from 'react-tooltip'
import Sidenavbar from '../../Components/Sidenavbar/Sidenavbar';
import UserMenu from '../../Components/UserMenu/UserMenu';
import DashboardCard from '../../Components/DashboardCard/DashboardCard';
import Paginator from '../../Components/Paginator/Paginator';
import { useNavigate } from 'react-router-dom';
import { postData, putData } from '../../Services/apiService';
import { useLocation } from 'react-router-dom';



const currentYear = new Date().getFullYear();
const startYear = 2022;
const years = [];
  for (let year = startYear; year <= currentYear; year++) {
    years.push({ value: year.toString(), label: year.toString() });
  }
  
function DetailsDashboard(props) {
  const navigate = useNavigate();
  const userType = 'admin';
  const [rows, setRows] = React.useState([]);
    const [filteredRows, setFilteredRows] = useState([]);  // Asegúrate de tener este estado con los datos filtrados

  const [show, setShow] = useState(false);
  const [cardInfo, setCardInfo] = useState({})
  const [translateInfo, setTranslateInfo] = useState({})
  const [comment, setComment] = useState("");
  const [searchTerm, setSearchTerm] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); 
  const [totalPages, setTotalPages] = useState(1);
  
  
  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredRows.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    const totalItems = filteredRows.length;
    const calculatedTotalPages = totalItems > 0 ? Math.ceil(totalItems / itemsPerPage) : 1;
    setTotalPages(calculatedTotalPages);
  }, [filteredRows, itemsPerPage]);
  useEffect(() => {
    if (filteredRows.length === 0) {
      setTotalPages(1); 
      setCurrentPage(1);
    }
  }, [filteredRows]);

  useEffect(() => {
    setCurrentPage(1); 
  }, [searchTerm]);

  useEffect(() => {
    const filtered = rows.filter((row) => {
      return row.some((cell) => {
        return cell && String(cell).toLowerCase().includes(searchTerm.toLowerCase());
      });
    });
    setFilteredRows(filtered);
  }, [rows, searchTerm]); 


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClose = () => {
    setShow(false);
    setCardInfo({});
    setComment("");  
  };  
  const handleShow = (id, usuario, cecoFuente, cecoDestino) => {
    setTranslateInfo({ id, usuario, cecoFuente, cecoDestino }); 
    setShow(true);
  };
    const location = useLocation();
  const { year, month, profile } = location.state || {};

  const handleGoBack = () => {
    navigate(-1);
  };
  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };
  const transformDataToRows = (data) => {
    if (!data || !data.data) return [];
  
    return data.data.map(item => {
      const row = [
        item.idSolicitud,
        item.usuario,
        item.fechaSolicitud,
        item.cecoFuente,
        item.cecoDestino,
        item.status, // Agregar el status como un string, sin el <span>
        item.fechaFinalizacion
      ];
  
      // Si es un perfil 1 (admin), agregar el botón de ver solicitud solo si el status es "Pendiente"
      if (profile === 1) {
        if (item.status === "Pendiente") {
          row.push(
            <span className="d-flex">
              <button
                className="button -icon"
                data-tooltip-id="see-request"
                data-tooltip-content="Ver solicitud"
                data-tooltip-place="bottom"
                onClick={() => handleShow(item.idSolicitud, item.usuario, item.cecoFuente, item.cecoDestino)}
              >
                <i className="fa-solid fa-eye"></i>
              </button>
            </span>
          );
        } else {
          row.push(<span className="d-flex" />);
        }
      } else {
        if (item.status !== "Pendiente" && item.status !== "Rechazada") {
          row.push(
            <span className="d-flex">
              <button
                className="button -icon"
                data-tooltip-id="see-request"
                data-tooltip-content="Ver solicitud"
                data-tooltip-place="bottom"
                onClick={() => handleShow(item.idSolicitud, item.usuario, item.cecoFuente, item.cecoDestino)}
              >
                <i className="fa-solid fa-eye"></i>
              </button>
            </span>
          );
        } else {
          row.push(<span className="d-flex" />);
        }
      }
  
      return row;
    });
  };
  
  

  useEffect(() => {
    

    fetchRequestsData();
  }, []);
  const fetchRequestsData = async () => {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const idUser = user.id || 0;
    try {
      const body = {
        idUser: idUser,
        profile: profile,
        year: year,
        month: month
      };
      const data = await postData('TrasferRequest/GetDetails', body);
      const rows = transformDataToRows(data);
    
      setRows(rows); 
    } catch (error) {
      console.error('Error fetching data:', error);
     
    }
  };
  useEffect(() => {
    

    fetchRequestsMonthlyData();
  }, []);
  const fetchRequestsMonthlyData = async () => {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const idUser = user.id || 0;
    try {
      const body = {
        idUser: idUser,
        profile: profile,
        year: year,
        month: month
      };
      const data = await postData('TrasferRequest/GetAll', body);
      if (data.succes) {
        const marchData = data.data.find(item => item.month === month);
        setCardInfo(marchData)

      }
    
    } catch (error) {
      console.error('Error fetching data:', error);
     
    }
  };


  const requestAcepted = async () => {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const idUser = user.id || 0;
      const requestData =  {
        idUser:idUser,
        profile: profile,
        comments: comment, 
        idRequest: translateInfo.id
      };
      if (profile === 1) {
        requestData.status = 2
      }
      else {
        requestData.status = 4
      }
      const requestDataJSON = JSON.stringify(requestData);

      const data = await putData('TrasferRequest', requestDataJSON);
      fetchRequestsData();
      handleClose();

      if(data.succes){
        toast.success('Solicitud aprobada', {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          });
      }
      else {
        
          toast.warning(data.errors, {
            position: "top-center",
            autoClose: true,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
            className: 'Toastify__toast -danger',
            }
          )
      }
      }
      

    const requestRejected = async () => {
      const user = JSON.parse(localStorage.getItem('user')) || {};
    const idUser = user.id || 0;
      const requestData = {
        idUser:idUser,
        profile: profile,
        comments: comment, 
        idRequest: translateInfo.id
      };
      if (profile === 1) {
        requestData.status = 3
        const requestDataJSON = JSON.stringify(requestData);

        const data = await putData('TrasferRequest', JSON.stringify(requestData));
        fetchRequestsData();
        handleClose();
        

         if(data.succes){
          toast.error('Solicitud rechazada', {
            position: "top-center",
            autoClose: true,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
            className: 'Toastify__toast -danger',
            });
          }
        else {
          
            toast.warning(data.errors, {
              position: "top-center",
            autoClose: true,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
            className: 'Toastify__toast -warning',
              }
            )
        }
        
        
        }
       
      
    } 
  return (
    <div className="container-fluid px-0 m-0 d-flex flex-column flex-md-row">
      <Sidenavbar userType={userType} />
      <div className="container-fluid px-16">
        <UserMenu userType="super" />
        <ToastContainer />

        <Modal
          size="lg"
          show={show}
          onHide={() => setShow(false)}
          aria-labelledby="modal-change-request-status"
        >
          <button className="btn -icon button-close" onClick={handleClose}>
            <i class="fa-solid fa-xmark"></i>
          </button>
          <Modal.Header className="justify-content-center">
            <Modal.Title>Nueva solicitud</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col">
                <p className="body-2">
                  {translateInfo.usuario} ha pedido transferir de {translateInfo.cecoFuente}, al  {translateInfo.cecoDestino}.
                </p>
              </div>
            </div>
            <div className="row mt-16">
              <div className="col">
                <label htmlFor="requestMessage" className="form-label d-block">Comentario</label>
                <textarea id="requestMessage" name="requestMessage" className='w-100' rows="2" cols="" value={comment} onChange={handleCommentChange} >
                </textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row justify-content-end">
              {profile === 1 && (
                <div className="col-12 col-md-6 col-lg-4">
                  <button className="btn -secondary" onClick={requestRejected}>
                    Rechazar solicitud
                  </button>
                </div>
              )}
              <div className="col-12 col-md-6 col-lg-4">
                <button className="btn -primary" onClick={requestAcepted}>
                  {profile === 1 ? "Aprobar solicitud" : "Ejecutar solicitud"}
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        {/* Detail */}
        <div className="row mt-40">
          <div className="col-12 col-md-6 col-lg-3">
            <a href="#">
              <button className="btn -text" onClick={handleGoBack}>
                <i class="fa-solid fa-arrow-left"></i> Regresar
              </button>
            </a>
          </div>
        </div>
        <div className="row mt-24">
          <div className="col-12">
           
            <DashboardCard 
              initialTitle={cardInfo.title}
              buttonText=""
              received={cardInfo.recibidas}
              pending={cardInfo.pendientes}
              approved={cardInfo.aprobadas}
              rejected={cardInfo.rechazadas}
            />
          </div>
        </div>
        <div className="row mt-40">
          <div className="col-12">
            <div className="card -raspberry">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      aria-label="Busca por nombre, puesto, etc."
                      placeholder="Busca por nombre, puesto, etc."
                      onChange={handleSearchChange}
                    />
                    <span class="input-group-text -raspberry">
                      <i class="fa-solid fa-magnifying-glass"></i>
                    </span>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-8 d-flex align-items-center justify-content-end">
                  <p className="body-2 mr-16">Mostrando</p>
                  <span className="counter mr-16">{currentItems.length}</span>
                  <p className="body-2">resultados</p>
                </div>
              </div>
              <div className="row mt-32">
                <div className="col-12">
                  <table className='rounded-corners'>
                    <Tooltip id="see-request" />
                    <thead>
                      <tr>
                        <th>
                          # de solicitud
                        </th>
                        <th>
                          Usuario
                        </th>
                        <th>
                          Fecha
                        </th>
                        <th>
                          Transfiere
                        </th>
                        <th>
                          Recibe
                        </th>
                        <th>
                          Estado
                        </th>
                        <th>
                          Fecha de finalización
                        </th>
                        <th>
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                    {currentItems.map((row, index) => (
                      <tr key={index}>
                        {row.map((cell, cellIndex) => {
                          // Verifica si la celda es el status para renderizarla con el estilo de la "pill"
                          if (cell === row[5]) { // Asumimos que el status está en la posición 5
                            return (
                              <td className="pl-16" key={cellIndex}>
                                <span className={`pill ${cell === 'Aprobada' ? '-success' : cell === 'Pendiente' ? '-warning' : '-danger'}`}>
                                  {cell}
                                </span>
                              </td>
                            );
                          }
                          return <td className="pl-16" key={cellIndex}>{cell}</td>;
                        })}
                      </tr>
                    ))}
                  </tbody>
                  </table>
                </div>
              </div>
              <div className="row mt-40">
                <div className="col d-flex justify-content-end">
                <Paginator 
                  currentPage={currentPage} 
                  totalPages={totalPages} 
                  onPageChange={onPageChange} 
                />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Detail */}

      </div>
    </div>
  );
}

export default DetailsDashboard;